import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { GET_PERMIT_BLUEPRINTS } from "../queries/getPermitBlueprints";

const ADD_BLUEPRINT_TO_ORGANIZATION = gql`
  mutation AddBlueprintToOrganization($blueprintId: String!, $organizationId: String!, $permitTypeName: String) {
    addBlueprintToOrganization(
      input: { blueprintId: $blueprintId, organizationId: $organizationId, permitTypeName: $permitTypeName }
    ) {
      permitType {
        id
        name
        blueprintKey
      }
    }
  }
`;

export function useAddBlueprintToOrganization() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation(ADD_BLUEPRINT_TO_ORGANIZATION, {
    errorPolicy: "all",
    refetchQueries: [{ query: GET_PERMIT_BLUEPRINTS }],
  });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}

